import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getProductDetails, getProductsOnCategory } from "../../redux/Slices/ProductSlice";
import slider1 from "./../../images/slider1.png";
import { getOneCategory } from "../../redux/Slices/CategorySlice";
import { getOneBrand } from "../../redux/Slices/BrandsSlice";

const UseViewProductDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true)
  const [CategoryLoading, setCategoryLoading] = useState(true)
  const [BrandLoading, setBrandLoading] = useState(true)
  const [similarProductLoading, setSimilarProductLoading] = useState(true)
  const [item, setItem] = useState([])
  const [imageCover, setImageCover] = useState("")
  const [images, setImages] = useState([])
  const [similarProducts, setSimilarProducts] = useState([])
  const [categoryName, setCategoryName] = useState("")
  const [BrandName, setBrandName] = useState("")
  const [rateValue, setRateValue] = useState("")
  const { productDetails, ProductsOnCategoryList } = useSelector((state) => state.ProductReducer);
  const { OneCategory } = useSelector((state) => state.CategoryReducer);
  const { oneBrand } = useSelector((state) => state.BrandsReducer);

  // handle get product details
  const handleGetProductDetails = async () => {
    setLoading(true)
    await dispatch(getProductDetails(id));
    setLoading(false)
  }

  // handle get category data
  const handleGetCategoryName = async () => {
    setCategoryLoading(true)
    await dispatch(getOneCategory(item.category))
    setCategoryLoading(false)
  }

  // handle get brand data
  const handleGetBrandName = async () => {
    setBrandLoading(true)
    await dispatch(getOneBrand(item.brand))
    setBrandLoading(false)
  }

  // handle get similar products 
  const handleGetSimilarProduct = async () => {
    setSimilarProductLoading(true)
    await dispatch(getProductsOnCategory({ CatId: item.category, limit: 4, page: 1 }))
    setSimilarProductLoading(false)
  }

  // run handle Get Product Details function
  useEffect(() => {
    handleGetProductDetails()
  }, []);

  // run handle get category data & get brand data & similar producst
  useEffect(() => {
    handleGetCategoryName();
    handleGetBrandName();
    handleGetSimilarProduct();
  }, [item]);

  // handle product details request response
  useEffect(() => {
    if (loading === false) {
      if (productDetails && productDetails.data) {
        setRateValue(productDetails.data.data.ratingsAverage)
        setItem(productDetails.data.data)
        setImageCover(productDetails.data.data.imageCover)
        if (productDetails.data.data.images.length > 0) {
          setImages([...productDetails.data.data.images.map((img) => ({ original: img }))])
        } else {
          setImages([{ original: slider1 }])
        }
      }
    }
  }, [loading])

  // handle category request response
  useEffect(() => {
    if (CategoryLoading === false) {
      if (item && OneCategory.data) {
        setCategoryName(OneCategory.data.data.name)
      }
    }
  }, [CategoryLoading])

  // handle brand request response
  useEffect(() => {
    if (BrandLoading === false) {
      if (item && oneBrand.data) {
        setBrandName(oneBrand.data.data.name)
      }
    }
  }, [BrandLoading])

  // handle similar Product request response
  useEffect(() => {
    if (similarProductLoading === false) {
      if (ProductsOnCategoryList && ProductsOnCategoryList.data){
        setSimilarProducts(ProductsOnCategoryList.data.data.slice(0,4))
      }
    }
  }, [similarProductLoading])

  return [item, images, categoryName, BrandName, similarProducts,rateValue];
};

export default UseViewProductDetails;
